import { render, staticRenderFns } from "./ItemsInstructions.vue?vue&type=template&id=c2052dfa&scoped=true&lang=pug&"
import script from "./ItemsInstructions.vue?vue&type=script&lang=ts&"
export * from "./ItemsInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsInstructions.vue?vue&type=style&index=0&id=c2052dfa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2052dfa",
  null
  
)

export default component.exports